import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { LoginService } from "src/app/services/login.service";

@Component({
  selector: "app-main-page",
  templateUrl: "./main-page.component.html",
  styleUrls: ["./main-page.component.css"],
})
export class MainPageComponent implements OnInit {
  waitingForLogOut: boolean = false;
  constructor(private router: Router, private loginService: LoginService) {}

  ngOnInit(): void {}

  logOut() {
    this.waitingForLogOut = true;
    this.loginService
      .logoutAdmin()
      .toPromise()
      .then((success) => {
        this.waitingForLogOut = false;
        this.router.navigateByUrl("adminLogin").then(() => {
          localStorage.removeItem("token");
        });
      })
      .catch((err) => {});
  }
}
